function initializeWllGallery(gallery) {
  if (gallery.dataset.wllGalleryReady === 'true') return;
  gallery.dataset.wllGalleryReady = 'true';

  const stage = gallery.querySelector('[data-wll-gallery-stage]');
  const zoomPanel = gallery.querySelector('[data-wll-gallery-zoom]');
  const zoomImage = gallery.querySelector('[data-wll-gallery-zoom-image]');
  const zoomHint = gallery.querySelector('[data-wll-gallery-zoom-hint]');
  const slides = [...gallery.querySelectorAll('[data-wll-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-wll-gallery-thumb]')];
  const moreButton = gallery.querySelector('[data-wll-gallery-more]');

  if (!stage || !zoomPanel || !zoomImage || slides.length === 0) return;

  function activeSlide() {
    return slides.find((slide) => !slide.hidden);
  }

  function syncZoomSource(slide) {
    const image = slide?.querySelector('.wll-pdp-gallery__hero-image');
    const zoomSrc = slide?.dataset.zoomSrc;
    const canZoom = Boolean(image && zoomSrc);

    stage.dataset.zoomable = canZoom ? 'true' : 'false';
    if (zoomHint) zoomHint.hidden = !canZoom;
    if (!canZoom) {
      stage.classList.remove('is-zooming');
      zoomImage.removeAttribute('src');
      return;
    }

    if (zoomImage.src !== zoomSrc) {
      zoomImage.src = zoomSrc;
    }
  }

  function setActive(mediaId) {
    const target = slides.find((slide) => slide.dataset.mediaId === String(mediaId));
    if (!target) return;

    slides.forEach((slide) => {
      slide.hidden = slide !== target;
      if (slide !== target) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
      }
    });

    thumbs.forEach((thumb) => {
      thumb.setAttribute('aria-current', thumb.dataset.mediaId === String(mediaId) ? 'true' : 'false');
    });

    syncZoomSource(target);
  }

  function positionZoom(normalizedX, normalizedY) {
    if (!zoomImage.naturalWidth || !zoomImage.naturalHeight) return;

    const viewport = zoomPanel.getBoundingClientRect();
    const sourceWidth = zoomImage.naturalWidth;
    const sourceHeight = zoomImage.naturalHeight;
    const coverScale = Math.max(viewport.width / sourceWidth, viewport.height / sourceHeight);
    const zoomFactor = 1.55;
    const renderedWidth = sourceWidth * coverScale * zoomFactor;
    const renderedHeight = sourceHeight * coverScale * zoomFactor;
    const travelX = Math.max(0, renderedWidth - viewport.width);
    const travelY = Math.max(0, renderedHeight - viewport.height);

    zoomImage.style.width = `${renderedWidth}px`;
    zoomImage.style.height = `${renderedHeight}px`;
    zoomImage.style.transform = `translate3d(${-normalizedX * travelX}px, ${-normalizedY * travelY}px, 0)`;
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => setActive(thumb.dataset.mediaId));
  });

  moreButton?.addEventListener('click', () => {
    gallery.querySelectorAll('.wll-pdp-gallery__thumb--overflow').forEach((thumb) => {
      thumb.hidden = false;
    });
    moreButton.remove();
  });

  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    const zoomInset = 0.1;
    const zoomSpan = 1 - zoomInset * 2;

    stage.addEventListener('mouseleave', () => stage.classList.remove('is-zooming'));

    stage.addEventListener('mousemove', (event) => {
      if (stage.dataset.zoomable !== 'true') return;

      const rect = stage.getBoundingClientRect();
      const rawX = (event.clientX - rect.left) / rect.width;
      const rawY = (event.clientY - rect.top) / rect.height;
      const insideZoomTarget = rawX >= zoomInset && rawX <= 1 - zoomInset && rawY >= zoomInset && rawY <= 1 - zoomInset;

      if (!insideZoomTarget) {
        stage.classList.remove('is-zooming');
        return;
      }

      stage.classList.add('is-zooming');
      const x = Math.max(0, Math.min(1, (rawX - zoomInset) / zoomSpan));
      const y = Math.max(0, Math.min(1, (rawY - zoomInset) / zoomSpan));
      positionZoom(x, y);
    });
  }

  gallery.closest('.wll-product-main')?.addEventListener('variant:update', (event) => {
    const featuredMediaId = event.detail?.resource?.featured_media?.id;
    if (featuredMediaId) setActive(featuredMediaId);
  });

  syncZoomSource(activeSlide());
}

function initializeWllGalleries(root = document) {
  root.querySelectorAll('[data-wll-pdp-gallery]').forEach(initializeWllGallery);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeWllGalleries());
} else {
  initializeWllGalleries();
}

document.addEventListener('shopify:section:load', (event) => initializeWllGalleries(event.target));
